module.exports = __webpack_public_path__ + "img/logo.bc016b83.png";